import type { Query } from '../index.tsx';
import { ASC } from './order-direction.tsx';
import { NAME } from './order-field.tsx';

export const initialQuery: Query = {
	orderField: NAME,
	orderDirection: ASC,
	page: 1,
	filter: '',
};
